/**
 * REST API client for report access control.
 * Report access via dash-api REST.
 */

const BASE = process.env.REACT_APP_AWP_API_URL || 'https://awp.minsky.ai';

function authHeaders() {
    const token = localStorage.getItem('access_token');
    return token
        ? {'Authorization': `Bearer ${token}`, 'Content-Type': 'application/json'}
        : {'Content-Type': 'application/json'};
}

export async function getReportAccessMap(reportId) {
    if (!reportId) return {};
    const resp = await fetch(
        `${BASE}/api/reports/${encodeURIComponent(reportId)}/access`,
        {headers: authHeaders()}
    );
    if (!resp.ok) {
        console.error('getReportAccessMap failed', resp.status);
        return {};
    }
    return resp.json();
}

export async function getUserRole(reportId, userId) {
    if (!reportId || !userId) return null;
    const resp = await fetch(
        `${BASE}/api/reports/${encodeURIComponent(reportId)}/access/${encodeURIComponent(userId)}`,
        {headers: authHeaders()}
    );
    if (resp.status === 404) return null;
    if (!resp.ok) throw new Error(`getUserRole ${resp.status}`);
    const data = await resp.json();
    return data.role ?? null;
}

export async function setUserAccess(reportId, userId, role) {
    if (!reportId || !userId || !role) throw new Error('setUserAccess requires reportId, userId, role');
    const resp = await fetch(
        `${BASE}/api/reports/${encodeURIComponent(reportId)}/access/${encodeURIComponent(userId)}`,
        {
            method: 'PUT',
            headers: authHeaders(),
            body: JSON.stringify({role}),
        }
    );
    if (!resp.ok) throw new Error(`setUserAccess ${resp.status}`);
}

export async function removeUserAccess(reportId, userId) {
    if (!reportId || !userId) throw new Error('removeUserAccess requires reportId, userId');
    const resp = await fetch(
        `${BASE}/api/reports/${encodeURIComponent(reportId)}/access/${encodeURIComponent(userId)}`,
        {method: 'DELETE', headers: authHeaders()}
    );
    if (!resp.ok) throw new Error(`removeUserAccess ${resp.status}`);
}
